import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest} from "../../api";

const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;

let name = userData ? userData.name : null;
let username = userData ? userData.username : null;
let coachId = userData ? userData.coach_id : null;
let coachExperience = userData ? userData.coach_experience : null;
let practiceExperience = userData ? userData.practice_experience : null;
let rating = userData ? userData.rating : 0;
let nationalCode = userData ? (userData.national_code ? `${userData.national_code}` : null) : null;
let img = userData ? userData.img : null;
let mobile = userData ? userData.mobile : null;
let certificate = userData ? userData.certificate : null;
let certs = userData ? userData.certs : null;
let wallet = userData ? userData.wallet : null;
let timing = userData ? userData.timing : null;
let birthday = userData ? userData.birthday : null;
let gender = userData ? userData.gender : null;
let cardNom = userData ? userData.card_nom : null;
let iban = userData ? userData.iban : null;
let explanation = userData ? userData.explanation : null;
let isActive = userData ? userData.is_active : null;
let gymId = userData ? userData.gym_id : null;
export const initialState = {
    name: name,
    username: username,
    coachId: coachId,
    coachExperience: coachExperience,
    practiceExperience: practiceExperience,
    rating: rating,
    nationalCode: nationalCode,
    img: img,
    mobile: mobile,
    certificate: certificate,
    certs: certs,
    wallet: wallet,
    timing: timing,
    birthday: birthday,
    gender: gender,
    cardNom: cardNom,
    iban: iban,
    explanation: explanation,
    isActive: isActive,
    gymId: gymId,
}

export const handleGetUserData = createAsyncThunk('splash/handleGetUserData', async() => {
    try{
        let response = await getRequest('/coach/info');
        const data = response.data;
        if (response?.ok && data?.name) {
            localStorage.setItem('userData', JSON.stringify(data));
        }
        return data
    }
    catch(error){
        console.log('error')
    }
})

const splashSlice = createSlice({
    name: 'splash',
    initialState: {
        userData: initialState,
    },
    reducers: {
        requestData: (state, action) => {
            return {
                ...state,
                userData: initialState
            };
        },
        getDataError: (state, action) => {
            return {
                ...state,
                userData: initialState
            };
        },
        handleLogOutUser: (state, action) => {
            return {
                ...state,
                userData: {
                    coachId: '',
                    name: '',
                    rating: '',
                    username: '',
                    img: '',
                    mobile: '',
                    certificate: '',
                    certs: '',
                    practiceExperience: '',
                    wallet: '',
                    timing: '',
                    coachExperience: '',
                    birthday: '',
                    gender: '',
                    cardNom: '',
                    iban: '',
                    explanation: '',
                    isActive: '',
                    gymId: '',
                }
            };
        }
    },
    extraReducers(builder){
        builder
            .addCase(handleGetUserData.fulfilled, (state, action) => {
                return {
                    ...state,
                    userData: {
                        coachId: action?.payload?.coach_id,
                        name: action?.payload?.name,
                        rating: action?.payload?.rating,
                        username: action?.payload?.username,
                        nationalCode: action?.payload?.nationalCode,
                        img: action?.payload?.img,
                        mobile: action?.payload?.mobile,
                        certificate: action?.payload?.certificate,
                        certs: action?.payload?.certs,
                        practiceExperience: action?.payload?.practice_experience,
                        wallet: action?.payload?.wallet,
                        timing: action?.payload?.timing,
                        coachExperience: action?.payload?.coach_experience,
                        birthday: action?.payload?.birthday,
                        gender: action?.payload?.gender,
                        cardNom: action?.payload?.card_nom,
                        iban: action?.payload?.iban,
                        explanation: action?.payload?.explanation,
                        isActive: action?.payload?.is_active,
                        gymId: action?.payload?.gym_id,
                    }
                };
            })
    }
})

export const {requestData, getDataError, handleLogOutUser} = splashSlice.actions

export const selectUserData = state => state.splash.userData

export default splashSlice.reducer

